import buildLocalizeFn from "date-fns/locale/_lib/buildLocalizeFn";
import { getDataFromGlobalVars } from './helper';

export default function getLocale() {
	var i18n = getDataFromGlobalVars('i18n');

	if ( !i18n ) {
		return {};
	}

	var dayValues = {
		narrow: i18n.days_short,
		abbreviated: i18n.days_short,
		wide: i18n.days,
	};

	var monthValues = {
		narrow: i18n.months_short,
		abbreviated: i18n.months_short,
		wide: i18n.months,
	};

	var localize = {
		day: buildLocalizeFn({
			values: dayValues,
			defaultWidth: "narrow",
		} ),
		month: buildLocalizeFn({
			values: monthValues,
			defaultWidth: "narrow",
			formattingValues: monthValues,
			defaultFormattingWidth: "narrow",
		}),
	};


	return {
		localize: localize,
		formatLong: {
			date: () => 'mm/dd/yyyy'
		}
	};
}